import { useDispatch, useSelector } from 'react-redux'
import { addTask, removeTask, clearTasks, updateTask } from 'store/downloadReducer'

export const useDownload = () => {
  const dispatch = useDispatch()
  const tasks = useSelector((state) => state.download.tasks)

  const addNewTask = (task) => {
    dispatch(addTask(task))
  }

  const removeTaskById = (taskId) => {
    dispatch(removeTask(taskId))
  }

  const clearAllTasks = () => {
    dispatch(clearTasks())
  }

  const updateTaskById = (task) => {
    dispatch(updateTask(task))
  }

  return { tasks, addNewTask, removeTaskById, clearAllTasks, updateTaskById }
}